import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap, takeUntil, tap } from 'rxjs/operators';
import { AppModulesType } from './../../../../../_shared/enums/appModulesType.enum';
import { Customer } from './../../../../../_shared/model/customer.model';
import { CalendarFilterSettings } from './../../../../../_shared/model/userGuiSettings/calendarFilterSettings.model';
import { CalendarUserGuiSettings } from './../../../../../_shared/model/userGuiSettings/calendarUserGuiSettings.model';
import { GuiUserContractorSettings } from './../../../../../_shared/model/userGuiSettings/guiUserContractorSettings.model';
import { ActiveModulesService } from './../../../../../_shared/services/activeModules.service';
import { HelperService } from './../../../../../_shared/services/helper.service';
import { SetCalendarFilter } from './../../../../../_shared/state/base/base.actions';
import { BaseState } from './../../../../../_shared/state/base/base.state';
import { CommonService } from './../../_services/common.service';
import { CustomerSearchType } from './customer-search-type.enum';

@Component({
    selector: 'main-cal-view-filters',
    templateUrl: './main-cal-view-filters.component.html',
    styles: [],
})
export class MainCalViewFiltersComponent implements OnInit {
    private onDestroy$ = new Subject<void>();
    public slotDuration: string;
    public guiSettings: CalendarUserGuiSettings;
    public isPatientAppModuleActive = false;
    public isCaseModuleActive = false;
    public searchCustomer: string;
    public customerSearchType: CustomerSearchType = CustomerSearchType.CALENDAR;
    public searchingCustomer = false;
    public searchFailed = false;
    public searchInput: Subject<string> = new Subject<string>();
    public customerSearchResult: Observable<Customer[]>;
    public selectedCustomer: Customer;

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onSearch: EventEmitter<string> = new EventEmitter();

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public onCustomerSelected: EventEmitter<Customer> = new EventEmitter();

    @Select(BaseState.GetUserSettings)
    userSettings: Observable<GuiUserContractorSettings>;

    @ViewChild('customersearch', { read: NgSelectComponent, static: true })
    customerSearch: NgSelectComponent;

    constructor(
        private store: Store,
        private helper: HelperService,
        public am: ActiveModulesService,
        private decimalPipe: DecimalPipe,
        private commonRest: CommonService,
    ) {}

    ngOnInit() {
        this.userSettings.pipe(takeUntil(this.onDestroy$)).subscribe(res => {
            if (res) {
                this.guiSettings = res.calendar;
                this.slotDuration = `00:${this.decimalPipe.transform(this.guiSettings.timeFrequency, '2.0')}:00`;
                this.customerSearchType = res.calendar?.filter?.customerSearchType || CustomerSearchType.CALENDAR;
            }
        });
        this.isPatientAppModuleActive = this.am.isAM(AppModulesType.PATIENT_APP);
        this.isCaseModuleActive = this.am.isAM(AppModulesType.CASE);
        this.initSearch();
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    public selectCustomer(customer): void {
        this.selectedCustomer = customer;
        this.onCustomerSelected.emit(customer);
    }
    private initSearch(): void {
        this.customerSearchResult = concat(
            of([]), // default items
            this.searchInput.pipe(
                filter(term => {
                    return term !== null && term?.length > 1;
                }),
                debounceTime(200),
                distinctUntilChanged(),
                tap(() => (this.searchingCustomer = true)),
                switchMap(term =>
                    this.commonRest.searchCustomers(term).pipe(
                        catchError(() => of([])), // empty list on error
                    ),
                ),
            ),
        );
    }

    public clearSearch(): void {
        //TODO
        this.customerSearch?.clearModel();
    }
    public changeCalendarTimeSpan(): void {
        // TODO Ignored with eslint-interactive on 2023-11-10
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const alertSettings: any = {
            html: `
                <div class="row">
                    <div class="col-lg-6">Od:  
                        <select class="form-control m-input mf-from" > 
                            <option>00:00</option>
                            <option>01:00</option> 
                            <option>02:00</option> 
                            <option>03:00</option> 
                            <option>04:00</option> 
                            <option>05:00</option> 
                            <option>06:00</option> 
                            <option selected>07:00</option> 
                            <option>08:00</option> 
                            <option>09:00</option> 
                            <option>10:00</option> 
                            <option>11:00</option> 
                        </select> 
                    </div>
                    <div class="col-lg-6">Do:
                        <select class="form-control m-input mf-to" > 
                            <option>12:00</option>
                            <option>13:00</option> 
                            <option>14:00</option> 
                            <option>15:00</option> 
                            <option>16:00</option> 
                            <option>17:00</option> 
                            <option>18:00</option> 
                            <option selected>19:00</option> 
                            <option>20:00</option> 
                            <option>21:00</option> 
                            <option>22:00</option> 
                            <option>23:00</option> 
                            <option>24:00</option> 
                        </select> 
                    </div>
                </div>
                `,
            preConfirm: () => {
                const from = (document.querySelector('.mf-from') as HTMLInputElement).value;
                const to = (document.querySelector('.mf-to') as HTMLInputElement).value;
                return { from: from, to: to };
            },
        };
        this.helper.displayAlert('Nastavi časovni razpon.', '', alertSettings).then(result => {
            if (result.value) {
                const tmp = _.cloneDeep(this.guiSettings.filter);
                tmp.from = result.value.from;
                tmp.to = result.value.to;
                this.store.dispatch(new SetCalendarFilter(tmp));
            }
        });
    }

    public searchCalendar(event): void {
        this.searchCustomer = event;
        this.onSearch.emit(event);
    }

    public hiddeDisplaySettings(): void {
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.visible = !tmp.visible;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }

    public onChangeShowResources() {
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.showResources = !tmp.showResources;
        if (!tmp.showResources) {
            tmp.showOnlyAvailable = false;
            tmp.showExternalAvailable = false;
            tmp.showExternalCustomerAvailable = false;
        }
        this.store.dispatch(new SetCalendarFilter(tmp));
    }
    public onChangeShowAvailable() {
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.showOnlyAvailable = !tmp.showOnlyAvailable;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }

    public onChangeShowWeekend() {
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.showWeekend = !tmp.showWeekend;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }
    public onChangeShowHolidays() {
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.showHolidays = !tmp.showHolidays;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }
    public onChangeServicesColor() {
        const tmp = _.cloneDeep(this.guiSettings.filter);
        tmp.showServicesColor = !tmp.showServicesColor;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }
    public changeCalendarTimeFrequency(freq: number): void {
        const data = _.cloneDeep(this.guiSettings);
        const filter = data.filter;
        if (_.isNil(data.timeFrequency)) {
            //ko se v prvo nastavi timeFrequency
            data.timeFrequency = 30;
        }
        if (freq && data.timeFrequency + freq >= 5 && data.timeFrequency + freq <= 60) {
            // TODO Ignored with eslint-interactive on 2023-11-10
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const tmp: any = freq + Number(this.slotDuration.split(':')[1]);
            this.slotDuration = `00:${this.decimalPipe.transform(tmp, '2.0')}:00`;
            data.timeFrequency += freq;
            this.store.dispatch(new SetCalendarFilter(filter, data.timeFrequency));
        }
    }

    public onChangeShowExternalAvailable(type: 'external' | 'customer') {
        const tmp = _.cloneDeep(this.guiSettings.filter);
        if (type === 'external') {
            tmp.showExternalAvailable = !tmp.showExternalAvailable;
        } else {
            tmp.showExternalCustomerAvailable = !tmp.showExternalCustomerAvailable;
        }

        this.store.dispatch(new SetCalendarFilter(tmp));
    }

    public changeCustomerSearchType(): void {
        if (this.customerSearchType == CustomerSearchType.CALENDAR) {
            this.customerSearchType = CustomerSearchType.LIST;
        } else {
            this.customerSearchType = CustomerSearchType.CALENDAR;
        }
        const tmp: CalendarFilterSettings = _.cloneDeep(this.guiSettings.filter);
        tmp.customerSearchType = this.customerSearchType;
        this.store.dispatch(new SetCalendarFilter(tmp));
    }
}
